import { Button } from "@progress/kendo-react-buttons";
import { useAppDispatch } from "../../../../app/hooks";
import type { SubBrandDto } from "../../../../contracts";
import type { CommercialSimulatorSubBrandAgentResponse } from "../../../../models/agentResponseModels";
import type { ChatMessageViewModel } from "../../../../models/chatMessageViewModel";
import { setCurrentCommercialPlan } from "../../../../slices/chatSlice";
import type { ChatControllerActions } from "../../../controller/useChatController";

type ActionButtonsProps = {
    isBusy: boolean;
    isReadOnly: boolean;
    selectedSubBrand: SubBrandDto | null;
    message: ChatMessageViewModel;
    actions: ChatControllerActions;
    plan: CommercialSimulatorSubBrandAgentResponse | undefined;
    canStartSimulation: boolean;
    hasStartedSimulation: boolean;
    onStartSimulation: () => void;
};

const ActionButtons: React.FC<ActionButtonsProps> = ({
    isBusy,
    isReadOnly,
    message,
    actions,
    plan,
    canStartSimulation,
    hasStartedSimulation,
    onStartSimulation
}) => {
    const dispatch = useAppDispatch();

    return (
        <div className="d-flex align-items-center gap-2 m-2 w-100">
            {!isBusy && !isReadOnly && !hasStartedSimulation && (
                <>
                    <Button
                        type="button"
                        fillMode="outline"
                        themeColor="error"
                        disabled={isBusy}
                        onClick={actions.cancelToolCallAsync}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="button"
                        disabled={isBusy || !canStartSimulation}
                        className="ms-auto"
                        themeColor="primary"
                        onClick={onStartSimulation}
                    >
                        Start Simulation
                    </Button>
                </>
            )}

            {plan != null && (
                <Button
                    type="button"
                    fillMode="outline"
                    themeColor="secondary"
                    size="small"
                    className="ms-auto"
                    onClick={() => {
                        dispatch(setCurrentCommercialPlan({
                            currentCommercialPlan: plan,
                            currentCommercialPlanMessageId: message.id
                        }));
                    }}
                >
                    Open generated plan
                </Button>
            )}
        </div>
    );
};

export default ActionButtons;
